import React, { useContext, useMemo } from 'react';
import { useLocation, UNSAFE_RouteContext } from 'react-router-dom';
import { buildGridScopeSegment, buildScreenScope } from '../utils/AntGridSettings';

// Phạm vi nghiệp vụ của các AntGrid bên trong — một phần của khoá cấu hình lưới (AntGridSettings).
// Khung chứa "mang đi được" (phiếu, popup, widget, màn cài đặt) khai báo đoạn phạm vi của mình để cấu hình lưới
// không phụ thuộc URL đang mở: cùng lưới chi tiết EXPOrder dù mở ở route phiếu hay trong popup đều chung khoá.
// Khung lồng nhau: đoạn trong cùng thắng. Không khung nào khai báo → AntGrid dùng route pattern của màn.
//
// Quy ước đoạn: voucher:<bảng> | pos:<bảng> | popup:<loại>:<bảng> | widget:<mã> | setting:<tên>

export const AntGridScopeContext = React.createContext(null);

export { buildGridScopeSegment };

export const useGridScope = () => useContext(AntGridScopeContext);

// Phạm vi dùng cho khoá cấu hình: khung chứa gần nhất (AntGridScope) — không có thì màn theo route pattern.
// Trả { scope, route } (route: route pattern đang mở, chỉ để tra cứu).
export const useGridSettingsScope = () => {
    const containerScope = useContext(AntGridScopeContext);
    const routeContext = useContext(UNSAFE_RouteContext);
    const location = useLocation();
    const route = useMemo(() => {
        const matches = routeContext && routeContext.matches instanceof Array ? routeContext.matches : [];
        const match = matches.length ? matches[matches.length - 1] : null;
        const pattern = match && match.route && match.route.path;
        return pattern && pattern !== '*' ? pattern : location.pathname;
    }, [routeContext, location.pathname]);
    const scope = useMemo(() => containerScope || buildScreenScope(route), [containerScope, route]);
    return { scope, route };
};

export default function AntGridScope({ segment, children }) {
    if (!segment) return <React.Fragment>{children}</React.Fragment>;
    return <AntGridScopeContext.Provider value={segment}>{children}</AntGridScopeContext.Provider>;
}
